import { Chip, Tooltip } from "@heroui/react";
import { Link } from "react-router-dom";

import { getLinkStatus } from "../utils";

import { Product } from "@/types";

export interface LinkedCellProps {
  product: Product;
}

export function LinkedCell({ product }: LinkedCellProps) {
  const scrapedProduct = product.scrapedProduct;
  const linkStatus = getLinkStatus(product);

  if (!scrapedProduct) {
    return (
      <Chip className="whitespace-nowrap" size="sm" variant="soft">
        {linkStatus.label}
      </Chip>
    );
  }

  const truncatedName =
    scrapedProduct.name.length > 20
      ? `${scrapedProduct.name.slice(0, 20)}...`
      : scrapedProduct.name;

  return (
    <div className="flex flex-col items-start gap-1">
      <Chip
        className="whitespace-nowrap"
        color={linkStatus.color === "primary" ? "accent" : linkStatus.color}
        size="sm"
        variant="soft"
      >
        {linkStatus.label}
      </Chip>
      <Tooltip delay={300}>
        <Link
          className="text-muted hover:text-foreground max-w-[140px] truncate text-xs hover:underline"
          to={`/scraped/products?name=${encodeURIComponent(scrapedProduct.name)}`}
        >
          {truncatedName}
        </Link>
        <Tooltip.Content>{scrapedProduct.name}</Tooltip.Content>
      </Tooltip>
    </div>
  );
}
